import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {SecureFuelService} from '../../service/securefuel/secureFuelService.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class VehiclePositionGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var eventGrid = this;
		setTimeout(function(){
			eventGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var eventGrid = this;
		var secureFuelDataTimeZone = TimeUtil.getSecureFuelDataTimeZone();
		var defaultFilterEnd = TimeUtil.formatDateForDateTimeInTimeZone(new Date(), secureFuelDataTimeZone);
		var defaultFilterStart = TimeUtil.formatDateForDateTimeInTimeZone(
			new Date(Date.now() - (60 * 60 * 1000)),
			secureFuelDataTimeZone
		);
		
		//search
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:search', ' Search')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterCustomer',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Customer Id',
					listeners: {
						input: {
							fn: function() {
								//actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterUnit',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Unit Id',
					listeners: {
						input: {
							fn: function() {
								//actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-date-time-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					step: 1,
					value: defaultFilterStart
				},
				{
					tag: 'vaadin-date-time-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					step: 1,
					value: defaultFilterEnd
				},				
				{
					tag: 'vaadin-checkbox',
					itemid: 'filterLatest',
					name: 'latest',
					label: 'Latest Only',
					listeners: {
						click: function(evt) {
							if (evt.target.checked) {
								ElementUtil.query(toolbar, 'filterStartDate').disabled = true;
								ElementUtil.query(toolbar, 'filterEndDate').disabled = true;
								ElementUtil.query(toolbar, 'filterUnit').disabled = true;
							} else {
								ElementUtil.query(toolbar, 'filterStartDate').disabled = false;
								ElementUtil.query(toolbar, 'filterEndDate').disabled = false;
								ElementUtil.query(toolbar, 'filterUnit').disabled = false;
							}						
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'vaadin-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems);
						}
					}
				}									
			]
		});		
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}
				},
				{						
					path: 'sourceEventId',
					header: 'Record Id',
					width: '7em'
				},
				{						
					path: 'sfApiId',
					header: 'SF API Id',
					width: '7em'
				},	
				{						
					path: 'source',
					header: 'Source',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'carrierId',
					header: 'Customer Id',					
					width: '7em'
				},
				{						
					path: 'unitId',					
					header: 'Unit ID',					
					width: '7em'
				},
				{						
					path: 'eventTime',
					header: 'Event Time',
					width: '14em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.eventTime);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'country',
					header: 'Country',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'latitude',
					header: 'Latitude',
					'text-align': 'center',
					width: '9em'
				},
				{						
					path: 'longitude',
					header: 'Longitude',
					'text-align': 'center',
					width: '9em'
				},
				{						
					path: 'tankCapacity',
					header: 'Tank Capacity',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'tankCurrentLevel',
					header: 'Tank Current Level',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'speed',
					header: 'Speed',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'driverId',
					header: 'Driver Id',
					'text-align': 'center',
					width: '7em'
				},					
				{						
					path: 'created',
					header: 'Create Date',
					'text-align': 'center',
					width: '14em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.created);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}			
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		//paging
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 500,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						var startFilterDts = TimeUtil.addTimeZoneOffset(
							ElementUtil.query(toolbar, 'filterStartDate').value,
							secureFuelDataTimeZone
						);
						var endFilterDts = TimeUtil.addTimeZoneOffset(
							ElementUtil.query(toolbar, 'filterEndDate').value,
							secureFuelDataTimeZone
						);						
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							start: startFilterDts,														
							end: endFilterDts,
							unitId: ElementUtil.query(toolbar, 'filterUnit').value,
							dateField: 'recordDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
														
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();

						};
						
						var customerId = ElementUtil.query(toolbar, 'filterCustomer').value;
						if (customerId) {	
							var latest = ElementUtil.query(toolbar, 'filterLatest').checked;
							var unitId = ElementUtil.query(toolbar, 'filterUnit').value;
							if (latest) {
								SecureFuelService.getGPSEventService().getLatestEventForCustomer(customerId, unitId, grid.currentFilter).then(function(record) {
									var normalizeResponse = {
										totalNumber: 0,
										data: [],
										results: 0
									};
									if (record && record.recId) {
										normalizeResponse.data.push(record);
										normalizeResponse.totalNumber = 1;
										normalizeResponse.results = 1;
									}
									
									successHandler(normalizeResponse);
								}, function(){
									loadMask.remove();
								});
							} else {
								SecureFuelService.getGPSEventService().getEventsForCustomer(grid.currentFilter, customerId).then(function(records) {
									successHandler(records);
								}, function(){
									loadMask.remove();
								});
							}
						} else {
							loadMask.remove();							
							ElementUtil.query(toolbar, 'filterCustomer').validate();								
							window.DL.MessageUtil.showToastError('A Customer Id must be selected');							
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});		
		
		var gridSelectionChange = function() {
			setTimeout(function(){
				var showMapButton = ElementUtil.query(toolbar, 'showMap');
				showMapButton.disabled = grid.selectedItems.length === 0;
			});
		};

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var customerId = ElementUtil.query(toolbar, 'filterCustomer').value;
				var unitId = ElementUtil.query(toolbar, 'filterUnit').value;
				if (!customerId) {
					ElementUtil.query(toolbar, 'filterCustomer').validate();
					window.DL.MessageUtil.showToastError('A Customer Id must be selected');
					return;
				}
				if (!unitId) {
					ElementUtil.query(toolbar, 'filterUnit').validate();
					window.DL.MessageUtil.showToastError('A unit must be selected');
					return;
				}
				var latest = ElementUtil.query(toolbar, 'filterLatest').checked;
				if (latest) {
					ExportUtil.exportGridItemsAsCsv(grid.items, 'dl-vehicle-positions.csv');
					return;
				}
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				exportFilter.unitId = unitId;
				SecureFuelService.getGPSEventService().exportEventsForCustomer(exportFilter, customerId);
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		eventGrid.append(flexLayout);		
			
		var actionRefresh = function () {
			pagingToolbar.loadPage(1);				
		};

		var actionShowMap = function(records) {
			if (!records || records.length === 0) {
				return;
			}
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map',
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();

						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});

						var mapToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									'class': 'spacer-toolbar-item',
									style: 'width: 225px;',
									permissions: [],
									children:[
										ElementUtil.makeIcon('vaadin:cogs', ' View')
									],
									properties: {
										menu: [
											{
												tag: 'vaadin-item',
												innerHTML: 'Show Satellite',
												listeners: {
													click: function() {
														map.showSatellite();
													}
												}
											},
											{
												tag: 'vaadin-item',
												innerHTML: 'Show Terrain',
												listeners: {
													click: function() {
														map.showTerrain();
													}
												}
											},
											{
												tag: 'vaadin-item',
												innerHTML: 'Show Transportation',
												listeners: {
													click: function() {
														map.showTransportation();
													}
												}
											}
										]
									}
								}
							]
						});

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								mapToolbar,
								map
							]
						});
						mapWin.addToContentElement(mapFlexLayout);

						var plotRecords = records.filter(function(record) {
							return record.latitude && record.longitude
								&& !isNaN(parseFloat(record.latitude))
								&& !isNaN(parseFloat(record.longitude));
						});
						if (plotRecords.length === 0) {
							return;
						}

						var firstUnitId = plotRecords[0].unitId;
						var sameUnit = plotRecords.every(function(record) {
							return record.unitId === firstUnitId;
						});

						setTimeout(function(){
							if (!sameUnit || plotRecords.length === 1) {
								plotRecords.forEach(function(record) {
									var date = TimeUtil.parseDate(record.eventTime || record.positionTime);
									var info = (record.unitId || '') + '<br>'
										+ TimeUtil.formatDateStandard(date) + '<br>'
										+ record.latitude + ', ' + record.longitude;
									map.addMarker([parseFloat(record.longitude), parseFloat(record.latitude)], {
										popupHTML: info
									});
								});
								if (plotRecords.length === 1) {
									setTimeout(function() {
										map.zoomOnPoint([
											parseFloat(plotRecords[0].longitude),
											parseFloat(plotRecords[0].latitude)
										]);
									}, 1000);
								}
							} else {
								plotRecords.sort(function(a, b){
									return TimeUtil.compare(a.eventTime || a.positionTime, b.eventTime || b.positionTime);
								});
								var loadMask = map.showLoading('Get Routing Options...');
								RoutingService.getGeospatialOptionsService().getOptionsForCurrentCompany().then(function(routeOptions){
									loadMask.remove();
									var request = map.translateRoutingOptions(routeOptions);
									request.routeId = ElementUtil.nextId();
									request.stops = [];
									plotRecords.forEach(function (record) {
										request.stops.push({
											longitude: parseFloat(record.longitude),
											latitude: parseFloat(record.latitude)
										});
									});
									map.route(request);
								});
							}
						}, 200);
					}
				}
			});
		};
		attachWorkspaceFilterState(eventGrid, toolbar, ['filterCustomer','filterUnit','filterStartDate','filterEndDate','filterLatest'], actionRefresh);
		
	}
	
}
customElements.define('dl-vehicle-position-grid', VehiclePositionGrid);

